class FormError extends Error {
  constructor(message, params) {
    super(message);
    this.params = params;
  }
}
FormError.prototype.name = "FormError";

export default FormError;
